export default "__VITE_ASSET__BlTP3TAa__"